import Base from '../base';
import constructDialog from '../../utils/webcomponents/construct-dialog';
import { DIALOG_SIZES } from '../dialog';

import { isWebinarRegistered, updatePageAfterRegistration } from './webinar-registration-storage';
import './webinar-registration-form';

// Button to trigger a dialog for webinar registration
class WebinarRegistration extends Base {
	start() {
		const { slug = '', status } = this.options;

		this.on('click');

		if (isWebinarRegistered(slug)) {
			updatePageAfterRegistration(slug, null, status);
		}
	}

	onClick() {
		WebinarRegistration.createDialog(this.options);
	}

	static createDialog(portfolioItem) {
		const tagName = 'x-webinar-registration-form';
		const options = { ...portfolioItem, amount: 1 };
		const { title } = options;

		constructDialog({ title, size: DIALOG_SIZES.medium }, tagName, {
			options: JSON.stringify(options),
		});
	}
}

export default WebinarRegistration;
